import Cookies from 'universal-cookie';
import http from '../utilities/httpUtils';

interface DynamicResponse {
  description: string;
  title: string;
  showInApp: boolean;
}
interface OutageResponse {
  title: string;
  message: string;
  image: any;
  showInApp: boolean;
}

export const fetchDynamicNotificationData = async () => {
  const existingCookie = getContentfulCookie();
  if (
    existingCookie?.visible !== undefined &&
    existingCookie?.visible === false
  ) {
    return;
  }

  try {
    const { title, description, showInApp } = await http.get<DynamicResponse>(
      'freightDynamicNotificationGet'
    )();

    setContentfulCookie(title, description, showInApp);
  } catch (e) {
    console.log('error => ' + e);
    setContentfulCookie(
      'Something went wrong.',
      'An unexpected error has occurred. Try again later.',
      false
    );
  }
};

export const fetchOutageData = async () => {
  try {
    const outageResponse = await http.get<OutageResponse>(
      'freightMcleodOutageNotificationGet'
    )();

    let formattedUrl = '';
    if (outageResponse.image) {
      formattedUrl =
        'https://' +
        outageResponse.image.fields.file.url.substr(
          2,
          outageResponse.image.fields.file.url.length
        );
    }
    outageResponse.image = formattedUrl;

    return outageResponse;
  } catch (e) {
    console.log('error => ' + e);
  }
};

export function getContentfulCookie() {
  const cookies = new Cookies();
  const contentfulCookies = cookies.get('contentfulData');
  return contentfulCookies;
}

export function setContentfulCookie(
  title: string,
  description: string,
  visible: boolean
) {
  const cookies = new Cookies();
  cookies.set(
    'contentfulData',
    { title: title, description: description, visible: visible },
    { maxAge: 900 }
  );
}
